<template lang="html">
    <ul class="main-menu__submenu">
        <li class="main-menu__item">
            <router-link v-bind:to="{ name: 'DealsNew' }" v-bind:class="activeMenuDeal">
                <md-icon>work</md-icon>
                <span>Заявки</span>
            </router-link>                     
        </li>
        <li class="main-menu__item">
            <router-link v-bind:to="{ name: 'Itineraries' }" v-bind:class="activeMenuRouteList">
                <md-icon>assignment</md-icon>
                <span>Маршрутные листы</span>
            </router-link>
        </li>
        <li class="main-menu__item">
            <router-link v-bind:to="{ name: 'Documents' }" v-bind:class="activeMenuDocument">
                <md-icon>receipt_long</md-icon>
                <span>Документы</span>
            </router-link>            
        </li>
    </ul>
</template>
<script>
export default {
    name: 'deals-main-menu',
    sort: 2,
    module: 'deals',
    data() {
        return  {
            module: 'deals'
        }
    },
    methods: {},
    computed: {
        activeMenuDeal() {
            let routes = ['DealsNew', 'DealNew'];
            return (routes.indexOf(this.$route.name)+1) ? this.$router.options.settingsLinkActiveClass : '';
        },
        activeMenuRouteList() {
            let routes = ['Itineraries', 'Itinerary'];
            return (routes.indexOf(this.$route.name)+1) ? this.$router.options.settingsLinkActiveClass : '';
        },
        activeMenuDocument() {
            let routes = ['Documents', 'Document'];
            return (routes.indexOf(this.$route.name)+1) ? this.$router.options.settingsLinkActiveClass : '';
        }
    },
}
</script>



// WEBPACK FOOTER //
// MainMenu.vue?b4541252